<!--
 * @Description: 学生单条查找带回
 * @Author: PF
 * @Date: 2023-03-02 15:19:39
 * @LastEditors: PF
 * @LastEditTime: 2026-10-10 16:15:17
-->
<template>
  <div class="jzg_insert">
    <el-dialog style="min-width: 770px;" class="w900 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">学生</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="mb0 pl0 pr0 pb0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box mb0" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="学号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable :teleported="false" @change="initZhuanYe();bindTable()">
                <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="层次" v-model="dataGrid.parms.ccid" clearable filterable :teleported="false" @change="initZhuanYe();bindTable()">
                <el-option v-for="item in ccData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable :teleported="false" @change="initBanJi();bindTable()">
                <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="年级" v-model="dataGrid.parms.njid" clearable filterable :teleported="false" @change="initBanJi();bindTable()">
                <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="班级" v-model="dataGrid.parms.bjid" clearable filterable :teleported="false" @change="bindTable()">
                <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-button type="success" @click="openGaoJiChaXunXueSheng=true"><span class="el-icon--left iconfont icon-sousuo" :style="dataGrid.parms.gaoJiQuery?'color:#ff0':''"></span>高级查询</el-button>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="mb0 pl0 pr0 pb0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" fixed align="center" width="80" />
            <el-table-column label="学号" prop="xh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <el-link type="primary" @click="openDetail=true;row={xsid:scope.row.id,xm:scope.row.xm}">{{scope.row.xm}}</el-link>
              </template>
            </el-table-column>
            <!-- 冻结列-Left END -->
            <el-table-column label="性别" prop="xb" width="60" align="center" show-overflow-tooltip />
            <el-table-column label="年级名称" prop="njmc" align="center" show-overflow-tooltip />
            <el-table-column label="系部名称" prop="xbmc" align="center" show-overflow-tooltip />
            <el-table-column label="专业名称" prop="zymc" align="center" show-overflow-tooltip />
            <el-table-column label="班级名称" prop="xzbmc" align="center" show-overflow-tooltip />
            <el-table-column label="当前状态" prop="xsdqzt" width="86" align="center" show-overflow-tooltip :formatter="ztFormat" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </div>
      </template>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <gaojichaxunxuesheng  v-if="openGaoJiChaXunXueSheng" v-model:openGaoJi="openGaoJiChaXunXueSheng" :row="dataGrid.parms.gaoJiQuery" @ReturnData="xueShengGaoJiRet" />
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, loadList, loadSelect } from '@/api/common'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import { getXjzt } from '@/utils/meiju.js'
import pagination from '@/components/pagination.vue'
import detail from '@/components/xuesheng/detail'
import gaojichaxunxuesheng from '@/components/gaojichaxun/xuesheng.vue'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

// 学生高级查询
const openGaoJiChaXunXueSheng = ref(false)
const xueShengGaoJiRet = (data) => {
  dataGrid.value.parms = {}
  if (data.length !== 0) {
    dataGrid.value.parms.gaoJiQuery = data
  }
  bindTable()
}
// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    pageSize: 20,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'xh', order: 'descending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/pdp/xuesheng/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 20,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      dataGrid.value.data = res.data.total === 0 ? [] : res.data.list
    }
  })
}
// 获取名称
const ztFormat = (row) => {
  const info = getXjzt().list.find(item => item.value === Number(row.xsdqzt))
  return info ? info.label : ''
}

// 加载 专业 下拉框
const zyData = ref()
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: {
      xbid: dataGrid.value.parms.xbid,
      ccid: dataGrid.value.parms.ccid
    },
    order: 'zybh',
    sort: 'asc'
  })
}

// 加载 年级 下拉框
const njData = ref()

// 加载 班级 下拉框
const bjData = ref()
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: bjData,
    parms: {
      zyid: dataGrid.value.parms.zyid,
      njid: dataGrid.value.parms.njid
    },
    order: 'xzbdm',
    sort: 'asc'
  })
}

// 加载 系部 下拉框
const xbData = ref()
// 加载 层次 下拉框
const ccData = ref()
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      dataGrid.value.parms = props.row || {}
      loadSelect({ url: '/api/v2/xiaoneijigou/listxibu', data: xbData, order: 'jgh', sort: 'asc' })
      loadZiDianSelect('层次', ccData, 'sx', 'asc')
      loadSelect({ url: '/api/v2/pdp/nianji/list', data: njData, order: 'njdm', sort: 'asc' })
      initZhuanYe()
      initBanJi()
      bindTable()
    }
  },
  { deep: true, immediate: true }
)

const row = ref()
const openDetail = ref(false)

const savestudent = (row) => {
  emits('ReturnData', row)
  handleClose()
}

const handleClose = () => {
  emits('update:openDanTiao', false)
}
</script>
